import { PayloadAction } from '@reduxjs/toolkit'
import { put, PutEffect, take, TakeEffect } from 'redux-saga/effects'
import fetchAllAssignmentsActions from '../../../actions/fetchAllAssignments'
import { AssignmentsActions } from '../../../actions/fetchAllAssignments/AssignmentsActions'
import fetchAllPhaseItemsActions from '../../../actions/fetchAllPhaseItems'
import { PhaseItemsActions } from '../../../actions/fetchAllPhaseItems/PhaseItemsActions'
import { ViewConstants } from '../../../actions/views/viewConstants'

const { FETCH_ALL_PHASE_ITEMS_SUCCESS, FETCH_ALL_PHASE_ITEMS_ERROR } =
  PhaseItemsActions
const { FETCH_ALL_ASSIGNMENTS_SUCCESS, FETCH_ALL_ASSIGNMENTS_ERROR } =
  AssignmentsActions

export type Payload = {
  view: ViewConstants
  viewKey?: string
  assignmentParams: Record<string, any>
  phaseItemParams: Record<string, any>
}

type FetchAction = PayloadAction<{ error?: string }>

type Yield = TakeEffect | PutEffect
type Return = void
type Next = FetchAction

const fallbackError = 'An unknown error occured in coordinateAssignmentFetches.'

export function* coordinateAssignmentFetches(
  payload: Payload
): Generator<Yield, Return, Next> {
  const { view, viewKey, assignmentParams, phaseItemParams } = payload

  yield put(
    fetchAllPhaseItemsActions.fetchPhaseItemsRequest({
      view,
      viewKey,
      params: phaseItemParams,
    })
  )

  const fetchPhaseItemOutcome = yield take([
    FETCH_ALL_PHASE_ITEMS_SUCCESS,
    FETCH_ALL_PHASE_ITEMS_ERROR,
  ])

  if (fetchPhaseItemOutcome.type === FETCH_ALL_PHASE_ITEMS_ERROR) {
    throw new Error(fetchPhaseItemOutcome.payload.error || fallbackError)
  }

  yield put(
    fetchAllAssignmentsActions.fetchAssignmentsRequest({
      view,
      viewKey,
      params: assignmentParams,
    })
  )

  const fetchAssignmentsOutcome = yield take([
    FETCH_ALL_ASSIGNMENTS_SUCCESS,
    FETCH_ALL_ASSIGNMENTS_ERROR,
  ])

  if (fetchAssignmentsOutcome.type === FETCH_ALL_ASSIGNMENTS_ERROR) {
    throw new Error(fetchAssignmentsOutcome.payload.error || fallbackError)
  }
}
